/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningRetrieve } from "../../funcs/llmFineTuningRetrieve.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RetrieveFineTuningJobRequest$inboundSchema,
};

export const tool$llmFineTuningRetrieve: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-retrieve",
  description: `Retrieve a fine-tuning job

Get info about a fine-tuning job.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningRetrieve(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
